import i18n from '@/locale';
import { USER_LS_KEY, ACCOUNT_LS_KEY, USER_HEADERS_KEY, LOCALE_LS_KEY, SASS_FLOW_NAME, } from '@/helpers/consts';
import { safeSetItem, clearAppointmentStorage } from '@/helpers/storage';
const setUserToStorage = (user) => {
    safeSetItem(USER_LS_KEY, JSON.stringify(user));
};
const setAccountToStorage = (account) => {
    safeSetItem(ACCOUNT_LS_KEY, JSON.stringify(account));
};
const setStorageLocale = (value) => {
    safeSetItem(LOCALE_LS_KEY, value);
};
const setXHeadersLocale = (user) => {
    const headersData = { 'auth_token': user.authentication_token, 'auth_email': user.email };
    safeSetItem(USER_HEADERS_KEY, JSON.stringify(headersData));
};
const getStorageXHeaders = () => {
    const user = window.localStorage.getItem(USER_HEADERS_KEY);
    return user ? JSON.parse(user) : null;
};
const getStorageLocale = () => {
    return window.localStorage.getItem(LOCALE_LS_KEY);
};
const getUserFromStorage = () => {
    const user = window.localStorage.getItem(USER_LS_KEY);
    return user ? JSON.parse(user) : null;
};
const getAccountFromStorage = () => {
    const account = window.localStorage.getItem(ACCOUNT_LS_KEY);
    return account ? JSON.parse(account) : null;
};
const removeUserFromStorage = () => {
    window.localStorage.removeItem(USER_LS_KEY);
    window.localStorage.removeItem(ACCOUNT_LS_KEY);
    window.localStorage.removeItem(SASS_FLOW_NAME);
    clearAppointmentStorage();
    i18n.locale = navigator.language;
};
const removeHeadersFromStorage = () => {
    window.localStorage.removeItem(USER_HEADERS_KEY);
    i18n.locale = navigator.language;
};
const isUserAuth = (store) => {
    const user = store.getters['GlobalStore/user'];
    return Boolean(user && (user.authentication_token || user.account_id));
};
const user = (store) => store.getters['GlobalStore/user'];
export { setUserToStorage, getAccountFromStorage, setXHeadersLocale, getStorageXHeaders, getUserFromStorage, removeUserFromStorage, removeHeadersFromStorage, isUserAuth, user, setStorageLocale, getStorageLocale, setAccountToStorage, };
